import { render, staticRenderFns } from "./SalesDashboard.vue?vue&type=template&id=3ba9b9f8&scoped=true"
import script from "./SalesDashboard.vue?vue&type=script&lang=js"
export * from "./SalesDashboard.vue?vue&type=script&lang=js"
import style0 from "./SalesDashboard.vue?vue&type=style&index=0&id=3ba9b9f8&prod&scoped=true&lang=css"
import style1 from "./SalesDashboard.vue?vue&type=style&index=1&id=3ba9b9f8&prod&scoped=true&lang=css"
import style2 from "./SalesDashboard.vue?vue&type=style&index=2&id=3ba9b9f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba9b9f8",
  null
  
)

export default component.exports